import {device} from "@yb/utils";
// import Desktop from "./Desktop";
import Mobile from "./Mobile";

const Floating = () => <>{device.current() === "Mobile" && <Mobile />}</>;

export default Floating;
